module.exports = __webpack_public_path__ + "static/media/rd-icon.2b4e8d22.png";